module.exports = __webpack_public_path__ + "static/media/zoom-out-button.6dfb401e.png";